import React, { useEffect, useState } from 'react';
import { useCall } from '../../../../../../context/temp';
import PhoneIcon from '@mui/icons-material/Phone';
import CallEndIcon from '@mui/icons-material/CallEnd';
import VideocamIcon from '@mui/icons-material/Videocam';

export default function IncomingCallModal() {
  const { incomingCall, acceptCall, rejectCall } = useCall();
  const [isVisible, setIsVisible] = useState(false);

  const BASE_DOWNLOAD_URL = process.env.REACT_APP_API_BASE_URL_DOWNLOAD;

  useEffect(() => {
    if (incomingCall) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [incomingCall]);

  if (!isVisible || !incomingCall) return null;

  const { from, type } = incomingCall;
  const callerName = `${from.username || 'Unknown User'}`;
  const callerAvatar = from.avatar
    ? `${BASE_DOWNLOAD_URL}${from.avatar}`
    : null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 animate-fadeIn">
      <div className="bg-gradient-to-b from-green-600 to-green-700 rounded-3xl shadow-2xl w-96 max-w-[90vw] overflow-hidden animate-slideUp">
        {/* Header */}
        <div className="text-center pt-12 pb-8 px-6">
          <div className="text-white text-sm font-medium mb-2">
            {type === 'video' ? 'Incoming Video Call' : 'Incoming Voice Call'}
          </div>
          
          {/* Caller Avatar */}
          <div className="relative inline-block mb-4">
            <div className="w-32 h-32 rounded-full bg-white shadow-lg overflow-hidden border-4 border-white animate-pulse">
              {callerAvatar ? (
                <img
                  src={callerAvatar}
                  alt={callerName}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-300 text-gray-700 text-4xl font-bold">
                  {callerName[0]?.toUpperCase()}
                </div>
              )}
            </div>
            
            {/* Ripple effect */}
            <div className="absolute inset-0 rounded-full border-4 border-white opacity-50 animate-ping"></div>
          </div>

          {/* Caller Name */}
          <h2 className="text-white text-2xl font-bold mb-1">{callerName}</h2>
          <p className="text-green-100 text-sm">Ringing...</p>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center items-center gap-16 pb-12 px-6">
          {/* Reject Button */}
          <button
            onClick={rejectCall}
            className="group relative"
            aria-label="Reject call"
          >
            <div className="w-16 h-16 rounded-full bg-red-500 hover:bg-red-600 shadow-lg flex items-center justify-center transition-all duration-200 group-hover:scale-110 active:scale-95">
              <CallEndIcon className="text-white text-3xl" />
            </div>
            <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 text-white text-xs whitespace-nowrap">
              Decline
            </span>
          </button>

          {/* Accept Button */}
          <button
            onClick={acceptCall}
            className="group relative"
            aria-label="Accept call"
          >
            <div className="w-16 h-16 rounded-full bg-green-400 hover:bg-green-500 shadow-lg flex items-center justify-center transition-all duration-200 group-hover:scale-110 active:scale-95 animate-bounce">
              {type === 'video' ? (
                <VideocamIcon className="text-white text-3xl" />
              ) : (
                <PhoneIcon className="text-white text-3xl" />
              )}
            </div>
            <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 text-white text-xs whitespace-nowrap">
              Accept
            </span>
          </button>
        </div>
      </div>

      <style >{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </div>
  );
}